import { useTranslation as O } from "react-i18next";
import { ServiceType as _ } from "../../../../../../../common/shared/serviceType.js";
import N from "../../../hooks/useOrderLater.js";
import Y from "../../../hooks/customization/useCustomization.js";
import { getCacheAddressInfoKey as D } from "../shared.js";
import { AddressValidationStatus as c } from "../../../shared/address-validation-status.enum.js";
import { useAddressValidation as K } from "../../../hooks/backend/useAddressValidation.js";
import { useOrdering as M } from "../context.js";
function q() {
  const { configuration: o, getTextTranslations: S, setLoader: A } = Y(), {
    setStep: u,
    setErrors: d
  } = M(), { t: i } = O(), {
    mutateAsync: x,
    isLoading: C
  } = K(), { orderLater: R } = N(), r = S("popup");
  async function b(a, s) {
    var g, L, y, I;
    const l = !s.place, w = ((g = s.place) == null ? void 0 : g.addressComponents.some((e) => e.types.includes("street_number"))) ?? !1, V = async (e) => {
      u({
        name: "restaurant-redirection",
        data: {
          service: a,
          restaurant: e,
          now: !0
        }
      });
    }, v = async (e) => {
      const t = await R(
        e,
        a,
        s.place
      );
      u({
        name: "time-selector",
        data: t
      });
    };
    if (a === _.DELIVERY) {
      const e = !s.addressInfo && (o == null ? void 0 : o.settings.popup.addressExtraMandatory);
      if (l && e) {
        d((t) => ({
          ...t,
          address: {
            textError: (r == null ? void 0 : r.error_address_both_empty) || i("shopLanding.address.error.addressBothEmpty")
          }
        }));
        return;
      }
      if (l) {
        d((t) => ({
          ...t,
          address: {
            textError: (r == null ? void 0 : r.error_address_empty) || i("shopLanding.address.error.addressEmpty")
          }
        }));
        return;
      }
      if (e) {
        d((t) => ({
          ...t,
          address: {
            textError: (r == null ? void 0 : r.error_address_info_empty) || i("shopLanding.address.error.addressInfoEmpty")
          }
        }));
        return;
      }
    }
    if (a === _.TAKEAWAY && l && o != null && o.settings.popup.addressMandatory) {
      d((e) => ({
        ...e,
        address: {
          textError: (r == null ? void 0 : r.error_address_empty) || i("shopLanding.address.error.addressEmpty")
        }
      }));
      return;
    }
    if (s.place && !w)
      return;
    A({
      text: (r == null ? void 0 : r.loading_restaurants) || i("shopLanding.loadingRestaurants") || ""
    }), localStorage.setItem(D(), s.addressInfo ?? "");
    const {
      status_code: h,
      restaurants: p
    } = await x({
      serviceType: a,
      address: ((L = s.place) == null ? void 0 : L.formattedAddress) ?? "",
      latitude: ((y = s.place) == null ? void 0 : y.lat) ?? 0,
      longitude: ((I = s.place) == null ? void 0 : I.long) ?? 0
    });
    if (A(null), h !== c.ACTIVE) {
      d((e) => ({
        ...e,
        address: {
          platform: {
            type: h,
            restaurants: []
          }
        }
      }));
      return;
    }
    const E = p.filter(
      (e) => e.status_code === c.ACTIVE
    );
    if (E.length === 0) {
      d((e) => ({
        ...e,
        address: {
          platform: {
            type: c.SUSPENDED,
            restaurants: p
          }
        }
      }));
      return;
    }
    const n = E.filter(
      (e) => e.is_now_available || e.is_schedule_available
    );
    if (n.length === 0) {
      d((e) => ({
        ...e,
        address: {
          platform: {
            type: c.LOCATION_TEMPORARILY_UNAVAILABLE,
            restaurants: p
          }
        }
      }));
      return;
    }
    if (n.length > 1 && a === _.TAKEAWAY) {
      l && n.sort((e, t) => e.name < t.name ? -1 : e.name > t.name ? 1 : 0), u({
        name: "restaurant-selector",
        data: {
          service: a,
          restaurants: n
        }
      });
      return;
    }
    const m = n.filter((e) => e.is_now_available), f = n.filter((e) => e.is_schedule_available);
    if (m.length > 0 && f.length === 0) {
      V(m[0]);
      return;
    }
    if (m.length === 0 && f.length > 0) {
      v(f);
      return;
    }
    u({
      name: "single-restaurant",
      data: {
        service: a,
        restaurants: n
      }
    });
  }
  return {
    proceed: b,
    isLoading: C
  };
}
export {
  q as useAddressServiceAction
};
//# sourceMappingURL=useAddressServiceAction.js.map
